import * as React from 'react'
// @ts-ignore
import { Handbook } from 'types'
// @ts-ignore
import Loader from 'ui/Loader'
// @ts-ignore
import { fetchBySlug as fetchHandbook } from '../../../data/school/handbook'
import EditableHandbookPage from './EditableHandbookPage'
// @ts-ignore
import HandbookPage from './HandbookPage'

interface IProps {
  schoolSlug: string
}

export default function HandbookEditor(props: IProps) {
  const { schoolSlug } = props
  const [handbook, setHandbook] = React.useState<Handbook>(null)
  const [requestInProgress, setRequestInProgress] = React.useState(false)

  const fetchData = async () => {
    try {
      setRequestInProgress(true)
      const handbookData = await fetchHandbook(schoolSlug)
      setHandbook(handbookData)
    } catch {
      return
    } finally {
      setRequestInProgress(false)
    }
  }

  React.useEffect(() => {
    fetchData()
  }, [])

  if (requestInProgress) return <Loader />
  if (!handbook) return null
  if (!handbook.id) return <EditableHandbookPage {...props} />
  if (!handbook.handbook) return <HandbookPage {...props} />
  return <EditableHandbookPage {...props} />
}
